import React, { useEffect } from "react";
import statisfi_back_logo from "../assets/images/satisfi_white.svg";
import './Redirect.scss';
export default function RedirectionComponent() {
    const [seconds, setSeconds] = React.useState(10)
    useEffect(() => {
        if (seconds === 0) {
            window.location.href = "https://me.satis.fi";
        } else {
            const interval = setInterval(() => setSeconds(seconds - 1), 1000);
            return () => clearInterval(interval);
        }

    }, [seconds])
    const handleNavigate = () => {
        window.location.href = "https://me.satis.fi";
    }
    return <div className="redirect-page width">
        <div className="box">

            <div>
                <img loading="lazy" src={statisfi_back_logo} alt="SatisFi Logo" />
            </div>
            <div className="content">
                <p>            Marketing Engine has moved to</p>
                <a href="https://me.satis.fi">me.satis.fi</a>
                <p className="content-footer">Please bookmark the new link for future use</p>
            </div>
            <div className="timerSection">
                <p>Redirecting in</p>
                <div className="timer">
                    0:0{seconds} Seconds
                </div>
            </div>
            <div className="redirectionButton" onClick={handleNavigate}>Continue to me.satis.fi</div>

        </div>
    </div>;
}
